export { pl } from '@payloadcms/translations/languages/pl'
